import React from 'react';
import styled from 'styled-components/macro';
import {
  Bold, Paragraph, Heading4, Heading1,
} from '../../components/typography';
import {
  Container,
  Row,
  Col,
  Div,
} from '../../components/grid';
import { ImagePopup } from '../../components/Image';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import { Item, PriceSum } from '../../containers/commerce';
import TheVideoPlayer from '../../components/TheVideoPlayer';
import { Grid } from './KulsyreTilFadoel';
import { Content } from './Kulsyre';
import ProductViewKulsyre from '../../components/commerce/ProductViews/ProductViewKulsyre';

const ImagePopupStyled = styled(ImagePopup)`
  border-radius: 15px;
  overflow: hidden;
`;


export default () => (
  <SidemenuLayout menuPicker="Kulsyre" activeSidemenu="KulsyreDrikkevandsKoeler">
    <Container white mb>
      <Row>
        <Col xs={12} id="drikkevandskoeler">
          <Heading1>Kulsyre til drikkevandskølere</Heading1>
          <Paragraph>
            <Bold>4kg og 6kg kulsyreflasker til alle typer drikkevandskølere og danskvandsanlæg</Bold>
          </Paragraph>
          <Paragraph>
            Både til rigtige drikkevandskølere, samt køleskab med indbygget vanddispenser.
          </Paragraph>
          <Paragraph>
            Vi sælger ikke 2kg engangskulsyre, som den på billedet. Men vi tilbyder en løsning så du kan bruge større kulsyreflasker til din drikkevandskøler - hvilket også er meget billigere end at købe engangskulsyre.
          </Paragraph>
          <Paragraph>
            Har du et system lignende det på billedet, så er løsningen at købe en ny regulator svarende til den på det andet billede til <PriceSum varenr="20600" itemPrice add={10000} />, hvor den sorte slange passer direkte på.
          </Paragraph>
          <Heading4>Kulsyreforbrug:</Heading4>
          <Paragraph>
            Der bruges ca. 10g CO2 pr. liter danskvand. En 4kgs flaske rækker altså til ca. 400 liter danskvand.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} md={4} textCenter>
          <ImagePopupStyled imageHeight="300px" maxHeight="300px" name="kulsyre.kulsyreVandkoeler.jpg" />
          <Paragraph fontSize="12px">Drikkevandskøler med lille engangskulsyreflaske</Paragraph>
        </Col>
        <Col xs={12} md={4} textCenter>
          <ImagePopupStyled imageHeight="300px" maxHeight="300px" name="kulsyre.kulsyre-gennem-skab.jpg" alt="Kulsyre gennem skab" title="Kulsyre gennem skab" />
          <Paragraph fontSize="12px">Kulsyre i tilpasset skab<br />(Tryk for at se større)</Paragraph>
        </Col>
        <Col xs={12} md={4} textCenter>
          <ImagePopupStyled imageHeight="300px" maxHeight="300px" name="kulsyre.kulsyre-gennem-skab-1.jpg" alt="Kulsyre gennem skab" title="Kulsyre gennem skab" />
          <Paragraph fontSize="12px">Kulsyre i tilpasset skab<br />(Tryk for at se større)</Paragraph>
        </Col>
      </Row>
    </Container>
    <Container mb>
      <Row>
        <Col xs={12} padding="0">
          <Grid>
            <Content product>
              <Item varenr="20601" middleImage display={ProductViewKulsyre} />
            </Content>
            <Content product>
              <Item
                varenr="8944"
                middleImage
                display={ProductViewKulsyre}
                secondDescription={(
                  <Paragraph bold>
                    Kulsyreflasken på 4kg er præcis 58,7cm høj. 56,5cm hvis man tager kraven af.
                  </Paragraph>
                )}
              />
            </Content>
            <Content product>
              <Item
                varenr="8940"
                middleImage
                display={ProductViewKulsyre}
              />
            </Content>
            <Content product>
              <TheVideoPlayer url="Sh0g0BRwa0o&t=446s" thumbnail="grohe" />
              <Div padding="15px">
                <Paragraph>
                  Grohe Blue leveres som standard med tilslutning til både små 425g flasker, samt vores 4kg eller 6kg kulsyreflasker.
                </Paragraph>
              </Div>
            </Content>
          </Grid>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
